import { BalancePolicy, IBalancePolicy } from '../../../../common/BalancePolicy'
import { getCashBoxBalancePolicy, setCashBoxBalancePolicy } from '../../../../common/core/_requests'

/**
 * Учёт баланса кассы — тот же блок, что у мерчанта: одна настройка, один вид.
 * Отличается только последствие отказа, поэтому оно и написано в подтверждении.
 */
export const CashBoxBalancePolicy = ({ cashBoxId }: { cashBoxId: number }) => (
  <BalancePolicy
    inputId='cashbox-enforce-balance'
    confirmText={
      'Касса не возьмёт в работу тикет, если его сумма больше остатка с учётом овердрафта. ' +
      'Правило одно для выплат и пополнений — перед включением сверьте остаток кассы.'
    }
    load={async () => {
      const res = await getCashBoxBalancePolicy(cashBoxId)

      return res.data?.success ? (res.data.data as IBalancePolicy | null) : null
    }}
    save={async (policy) => {
      const res = await setCashBoxBalancePolicy(cashBoxId, policy)

      return res.data?.success ? (res.data.data as IBalancePolicy | null) : null
    }}
  />
)
